import { orderMonthCollection } from "@/firebase";

const state = {
  orderMonth: {},
};

const getters = {};

const actions = {
  // eslint-disable-next-line
  getOrderMonth({ commit }, payload) {
    orderMonthCollection
      .where("client", "==", payload.client)
      .limit(1)
      .onSnapshot((snapshot) => {
        if (snapshot.empty) {
          commit("getOrderMonth", {
            client: payload.client,
            orderNum: 0,
            totalCopies: 0,
            itemCopies: 0,
            totalSumCart: 0,
          });
        } else {
          let tempData = {};
          snapshot.docChanges().forEach(
            (change) => {
              tempData = Object.assign(change.doc.data(), {
                id: change.doc.id,
              });
              //console.log(tempData);
              if (change.type == "added") {
                //console.log("Day added.");
                commit("getOrderMonth", tempData);
              } else if (change.type == "modified") {
                //console.log("Day modified.");
                commit("getOrderMonth", tempData);
              } else if (change.type == "removed") {
                //console.log("Day deleted.");
                //commit("deleteRoom", tempData);
              }
            },
            (error) => {
              console.log(error);
            }
          );
        }
      });
  },
};

const mutations = {
  getOrderMonth(state, payload) {
    state.orderMonth = payload;
    //console.log(state.orderMonth);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
